import qs from "qs";
import environment from "environment";
import type { CancelToken, AxiosResponse } from "axios";
import type { Filters, Sorting } from "@fas/ui-framework";
import { requestService } from "../request";
import type { LinkingInfo } from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";

export const getLinkingList = (options: {
  filters: Filters,
  sorting: Sorting,
}): Promise<Array<LinkingInfo>> => requestService.get(environment.endpoints.get.linkingList, {
  params: { ...options },
  paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
});
export default getLinkingList;

export const getLinkingInfo = (id: string): Promise<AxiosResponse<LinkingInfo>> => requestService
  .get(environment.endpoints.get.linking.replace("{linkingId}", id));

export const deleteLinking = (id: string): Promise<any> => requestService
  .delete(environment.endpoints.delete.linking.replace("{linkingId}", id));

export const bulkDeleteLinking = (deleteIds: Array<string>): Promise<any> => requestService
  .delete(environment.endpoints.delete.linkingBulk, {
    data: { deleteIds },
  });

export const createLinkingInfo = (item: LinkingInfo): Promise<LinkingInfo> => requestService
  .post(environment.endpoints.post.linking, item);

export const updateLinkingInfo = (id: string, item: LinkingInfo): Promise<LinkingInfo> => requestService
  .put(environment.endpoints.put.linking.replace("{linkingId}", id), item);

export const getTags = (
  // eslint-disable-next-line default-param-last
  name: string = "",
  cancelToken?: CancelToken
): Promise<any> => requestService.get(environment.endpoints.get.tags, {
  cancelToken,
  params: { filters: { name }, limit: 100 },
  paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
});

export const getHeight = async (tag: Array<string>): Promise<any> => requestService
  .get(environment.endpoints.get.documentsList, {
    params: { filters: { tag, type: "pft" }, page: 1, pageSize: 1 },
    paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: "brackets", encode: false }),
  });
